import { useEffect, useRef, useState } from 'react';
import GusAvatar0 from "./avatars/GusAvatar_0000.png";
import GusAvatar1 from "./avatars/GusAvatar_0001.png";
import GusAvatar2 from "./avatars/GusAvatar_0002.png";
import GusAvatar3 from "./avatars/GusAvatar_0003.png";
import PapaAvatar0 from "./avatars/PapaAvatar_0000.png";
import PapaAvatar1 from "./avatars/PapaAvatar_0001.png";
import PapaAvatar2 from "./avatars/PapaAvatar_0002.png";
import PapaAvatar3 from "./avatars/PapaAvatar_0003.png";
import DraugrAvatar0 from "./avatars/DraugrAvatar_0000.png";
import DraugrAvatar1 from "./avatars/DraugrAvatar_0001.png";
import DraugrAvatar2 from "./avatars/DraugrAvatar_0002.png";
import DraugrAvatar3 from "./avatars/DraugrAvatar_0003.png";
import ElfAvatar0 from "./avatars/ElfAvatar_0000.png";
import ElfAvatar1 from "./avatars/ElfAvatar_0001.png";
import ElfAvatar2 from "./avatars/ElfAvatar_0002.png";
import ElfAvatar3 from "./avatars/ElfAvatar_0003.png";
import JotunnAvatar0 from "./avatars/JotunnAvatar_0000.png";
import JotunnAvatar1 from "./avatars/JotunnAvatar_0001.png";
import JotunnAvatar2 from "./avatars/JotunnAvatar_0002.png";
import JotunnAvatar3 from "./avatars/JotunnAvatar_0003.png";
import TrollAvatar0 from "./avatars/TrollAvatar_0000.png";
import TrollAvatar1 from "./avatars/TrollAvatar_0001.png";
import TrollAvatar2 from "./avatars/TrollAvatar_0002.png";
import TrollAvatar3 from "./avatars/TrollAvatar_0003.png";
import SigridAvatar0 from "./avatars/SigridAvatar_0000.png";
import SigridAvatar1 from "./avatars/SigridAvatar_0001.png";
import SigridAvatar2 from "./avatars/SigridAvatar_0002.png";
import SigridAvatar3 from "./avatars/SigridAvatar_0003.png";
import MamaAvatar0 from "./avatars/MamaAvatar_0000.png";
import MamaAvatar1 from "./avatars/MamaAvatar_0001.png";
import MamaAvatar2 from "./avatars/MamaAvatar_0002.png";
import MamaAvatar3 from "./avatars/MamaAvatar_0003.png";
import DaleAvatar0 from "./avatars/DaleAvatar_0000.png";
import DaleAvatar1 from "./avatars/DaleAvatar_0001.png";
import DaleAvatar2 from "./avatars/DaleAvatar_0002.png";
import DaleAvatar3 from "./avatars/DaleAvatar_0003.png";
import HelgaAvatar0 from "./avatars/HelgaAvatar_0000.png";
import HelgaAvatar1 from "./avatars/HelgaAvatar_0001.png";
import HelgaAvatar2 from "./avatars/HelgaAvatar_0002.png";
import HelgaAvatar3 from "./avatars/HelgaAvatar_0003.png";
import OakenAvatar0 from "./avatars/OakenAvatar_0000.png";
import OakenAvatar1 from "./avatars/OakenAvatar_0001.png";
import OakenAvatar2 from "./avatars/OakenAvatar_0002.png";
import OakenAvatar3 from "./avatars/OakenAvatar_0003.png";
import StigAvatar0 from "./avatars/StigAvatar_0000.png";
import StigAvatar1 from "./avatars/StigAvatar_0001.png";
import StigAvatar2 from "./avatars/StigAvatar_0002.png";
import StigAvatar3 from "./avatars/StigAvatar_0003.png";
import './Icon.css';

const GusArr = [GusAvatar0, GusAvatar1, GusAvatar2, GusAvatar3];
const PapaArr = [PapaAvatar0, PapaAvatar1, PapaAvatar2, PapaAvatar3];
const DraugrArr = [DraugrAvatar0, DraugrAvatar1, DraugrAvatar2, DraugrAvatar3];
const ElfArr = [ElfAvatar0, ElfAvatar1, ElfAvatar2, ElfAvatar3];
const JotunnArr = [JotunnAvatar0, JotunnAvatar1, JotunnAvatar2, JotunnAvatar3];
const TrollArr = [TrollAvatar0, TrollAvatar1, TrollAvatar2, TrollAvatar3];
const SigridArr = [SigridAvatar0, SigridAvatar1, SigridAvatar2, SigridAvatar3];
const MamaArr = [MamaAvatar0, MamaAvatar1, MamaAvatar2, MamaAvatar3];
const DaleArr = [DaleAvatar0, DaleAvatar1, DaleAvatar2, DaleAvatar3];
const HelgaArr = [HelgaAvatar0, HelgaAvatar1, HelgaAvatar2, HelgaAvatar3];
const OakenArr = [OakenAvatar0, OakenAvatar1, OakenAvatar2, OakenAvatar3];
const StigArr = [StigAvatar0, StigAvatar1, StigAvatar2, StigAvatar3];

const allAvatars = [
  ...GusArr, ...PapaArr, ...DraugrArr, ...ElfArr,
  ...JotunnArr, ...TrollArr, ...SigridArr, ...MamaArr,
  ...DaleArr, ...HelgaArr, ...OakenArr, ...StigArr
];

const CHARACTER_FRAMES = {
  Sigrid: SigridArr,
  Mama: MamaArr,
  Papa: PapaArr,
  "Uncle Stig": StigArr,
  Dale: DaleArr,
  "Healer Helga": HelgaArr,
  "Chief Oaken": OakenArr,
  Draugrs: DraugrArr,
  Elves: ElfArr,
  Jotunns: JotunnArr,
  Trolls: TrollArr,
};

const FRAMERATE = 63;

function Icon({ character = "Gus", setCharState }) {
  const imgRef = useRef(null);
  const animationIntervalRef = useRef(0);
  const [frame, setFrame] = useState(0);

  const frames = CHARACTER_FRAMES[character] || GusArr;

  useEffect(() => {
    allAvatars.forEach((imageSrc) => {
      const img = new Image();
      img.src = imageSrc;
    });
  }, []);

  const stopAnim = () => {
    if (animationIntervalRef.current) {
      clearInterval(animationIntervalRef.current);
      animationIntervalRef.current = 0;
    }
  };

  useEffect(() => stopAnim, []);

  const startForwardAnim = () => {
    stopAnim();
    animationIntervalRef.current = setInterval(() => {
      setFrame((f) => {
        if (f < frames.length - 1) {
          return f + 1;
        }
        stopAnim();
        return f;
      });
    }, FRAMERATE);
  };

  const startBackwardAnim = () => {
    stopAnim();
    animationIntervalRef.current = setInterval(() => {
      setFrame((f) => {
        if (f > 0) {
          return f - 1;
        }
        stopAnim();
        return f;
      });
    }, FRAMERATE);
  };

  const handleClick = () => {
    setCharState();
    const iRef = document.querySelector(".character-card-image");
    iRef?.classList.add("animate-in");
    imgRef.current?.classList.add("animate-shrink");
    document.getElementById('bio')?.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      iRef?.classList.remove("animate-in");
      imgRef.current?.classList.remove("animate-shrink");
    }, 500);
  };

  return (
    <div>
      <img
        ref={imgRef}
        className="icon-button"
        src={frames[frame]}
        onMouseEnter={startForwardAnim}
        onMouseLeave={startBackwardAnim}
        onClick={handleClick}
        alt={`${character} icon`}
      />
    </div>
  );
}

export default Icon;
